/**
 * Handle lazy loading select images after document load is
 * complete (singleton).
 */
window.ImageLazyLoader = (function() {
    var imageContainer =  $('.propPreviewLeft');
    var viewImageFull = $('#viewImageFullScreen');
   imageContainer
       .on('mouseover', function() {
           if(window.t) {
               clearTimeout(window.t);
               window.t = undefined;
               imageContainer.addClass('hover');
               viewImageFull.css({
                   display: 'block'
               }).show().animate({height: '75px'});
           } else {
               imageContainer.addClass('hover');
               $('#viewImageFullScreen').css({
                   height: 0,
                   display: 'block'
               }).show().animate({height: '75px'});
           }
        })
       .on('mouseout', function() {
          window.t = setTimeout(function() {
             imageContainer.removeClass('hover');
              viewImageFull.css({
                height: '75px',
             }).animate({height: 0});
          }, 200)
       });

   function isVisible(jImg) {
      var visibleRange = $(window).height() + $(window).scrollTop(),
          imageY = $(jImg).offset().top;

      return visibleRange >= imageY;
   }

   function loadImages(_jImages) {
      setTimeout( function() {
         var jImages = (_jImages && _jImages.jquery) ? _jImages : $("img.lazyLoad");
         jImages.each(function(i) {
            var jImg = $(this),
               img = new Image(),
               strRefSrc = jImg.attr('ref'),
               strNewSrc = jImg.attr('rel');

            jImg.on("click", function() {
               window.initializeFullScreenView(i);
            });

            img.onerror = function() {
               jImg.attr('src', strRefSrc);
            };

            if (isVisible(jImg)) {
               jImg.attr('src', strNewSrc);
            }
         });

         $(window).on("scroll", function(e) {
            jImages.each(function(i) {
               var jImg = $(this),
                   strNewSrc = jImg.attr('rel');

               if (isVisible(jImg)) {
                  jImg.attr('src', strNewSrc);
               }
            });
         });
      }, 100);
   }
    viewImageFull.on('click', function() {
       window.initializeFullScreenView(0);
   }) ;
   $(document).ready(loadImages);

   return {
      loadImages : loadImages,
      loadImagesIn: function(jContainer) {
         var jImages = jContainer.find("img.lazyLoad");
         loadImages(jImages);
      }
   }
}());
